var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from 'styled-components';
import CustomPicker from 'react-color/lib/Custom';
import { Alpha, Saturation, EditableInput, Hue, } from 'react-color/lib/components/common';
var styles = {
    input: {
        width: '80px',
        fontSize: 14,
        padding: '3px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
    },
};
var ColorPickerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  width: 100%;\n"])));
var SaturationContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  position: relative;\n  width: 100%;\n"], ["\n  height: 100%;\n  position: relative;\n  width: 100%;\n"])));
var HueContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 20px 15px 0;\n  min-height: 4px;\n  position: relative;\n"], ["\n  margin: 20px 15px 0;\n  min-height: 4px;\n  position: relative;\n"])));
var AlphaContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 25px 15px 0;\n  min-height: 4px;\n  position: relative;\n"], ["\n  margin: 25px 15px 0;\n  min-height: 4px;\n  position: relative;\n"])));
var InputContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: left;\n  margin: 15px auto 5px 20px;\n  text-align: center;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: left;\n  margin: 15px auto 5px 20px;\n  text-align: center;\n  width: 100%;\n"])));
var Pointer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background: white;\n  border-radius: 50%;\n  box-shadow: rgba(0, 0, 0, 0.6) 0 2px 2px;\n  height: 20px;\n  margin-left: -8px;\n  margin-top: -9px;\n  width: 20px;\n"], ["\n  background: white;\n  border-radius: 50%;\n  box-shadow: rgba(0, 0, 0, 0.6) 0 2px 2px;\n  height: 20px;\n  margin-left: -8px;\n  margin-top: -9px;\n  width: 20px;\n"])));
var SwatchContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 15px 25px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 15px 25px;\n"])));
var Swatch = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  border: 1px solid #ddd;\n  border-radius: 2px;\n  cursor: pointer;\n  height: 16px;\n  transition: transform 0.1s ease;\n  width: 16px;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"], ["\n  border: 1px solid #ddd;\n  border-radius: 2px;\n  cursor: pointer;\n  height: 16px;\n  transition: transform 0.1s ease;\n  width: 16px;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"])));
var ClearSwatch = styled(Swatch)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  background: linear-gradient(\n      to top left,\n      rgba(255, 0, 0, 0) 0%,\n      rgba(255, 0, 0, 0) calc(50% - 1px),\n      rgba(255, 0, 0, 1) 50%,\n      rgba(255, 0, 0, 0) calc(50% + 1px),\n      rgba(255, 0, 0, 0) 100%\n    ),\n    white;\n"], ["\n  background: linear-gradient(\n      to top left,\n      rgba(255, 0, 0, 0) 0%,\n      rgba(255, 0, 0, 0) calc(50% - 1px),\n      rgba(255, 0, 0, 1) 50%,\n      rgba(255, 0, 0, 0) calc(50% + 1px),\n      rgba(255, 0, 0, 0) 100%\n    ),\n    white;\n"])));
var defaultSwatches = [
    '#36e0b7',
    '#0e3951',
    '#222',
    '#000',
    '#fff',
    'hotpink',
    'rebeccapurple',
    'green',
    'blue',
    'red',
];
var ColorPicker = function (props) {
    var _a, _b;
    var swatches = props.swatches
        ? props.swatches
        : ((_b = (_a = props === null || props === void 0 ? void 0 : props.appStyle) === null || _a === void 0 ? void 0 : _a.swatches) === null || _b === void 0 ? void 0 : _b.length)
            ? __spreadArray([
                props.appStyle.primaryColor,
                props.appStyle.secondaryColor
            ], props.appStyle.swatches, true) : defaultSwatches;
    return (_jsxs(ColorPickerContainer, { children: [_jsx(SaturationContainer, __assign({ onMouseDown: function (e) { return e.preventDefault(); } }, { children: _jsx(Saturation, __assign({}, props)) })), _jsx(HueContainer, __assign({ onMouseDown: function (e) { return e.preventDefault(); } }, { children: _jsx(Hue, __assign({}, props, { pointer: Pointer })) })), props.alpha && (_jsx(AlphaContainer, __assign({ onMouseDown: function (e) { return e.preventDefault(); } }, { children: _jsx(Alpha, __assign({}, props, { pointer: Pointer })) }))), _jsxs(InputContainer, { children: [_jsx("h4", __assign({ style: { margin: '0 15px 0 0' } }, { children: "Hex" })), _jsx(EditableInput, __assign({}, props, { label: "hex", style: {
                            input: __assign(__assign({}, styles.input), props.inputStyle),
                            label: {
                                display: 'none',
                            },
                        }, value: props && props.hex && props.hex !== 'transparent'
                            ? props.hex
                            : '#000000' }))] }), _jsxs(SwatchContainer, { children: [props.clearSwatch && (_jsx(ClearSwatch, { onClick: function () { return props.onChange('transparent'); } })), swatches.map(function (color, i) { return (_jsx(Swatch
                    // eslint-disable-next-line react/no-array-index-key
                    , { style: {
                            background: color,
                        }, onClick: function () { return props.onChange(color); } }, i)); })] })] }));
};
// custom  picker HOC to persist local state
// require the component consumer to mount and unmount it after every use (which the popover is already doing)
var StatefulPicker = function (_a) {
    var Component = _a.Component, props = __rest(_a, ["Component"]);
    var _b = useState(props.color), selectedColor = _b[0], setSelectedColor = _b[1];
    var onChange = function (color) {
        setSelectedColor((color && color.hex) || null);
        props.onChange(color);
    };
    return (_jsx(Component, __assign({}, props, { color: selectedColor, hex: selectedColor, onChange: onChange })));
};
var UncontrolledCustomPickerHOC = function (Component) { return (_jsx(StatefulPicker, { Component: Component })); };
export default CustomPicker(ColorPicker);
export var UncontrolledColorPicker = UncontrolledCustomPickerHOC(CustomPicker(ColorPicker));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
